export default __webpack_public_path__ + "static/media/airtableIcon.d222e223.svg";